import { render } from "./Rule.vue?vue&type=template&id=33f5747a&scoped=true"
import script from "./Rule.vue?vue&type=script&lang=js"
export * from "./Rule.vue?vue&type=script&lang=js"

import "./Rule.vue?vue&type=style&index=0&id=33f5747a&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33f5747a"]])

export default __exports__